import { Card, CardContent, CardHeader, Typography } from '@material-ui/core';

interface EmptyChartProps {
  title: string;
}

export const EmptyChart = ({ title }: EmptyChartProps) => (
  <Card>
    <CardHeader title={title} />
    <CardContent>
      <Typography variant="body2" color="textSecondary" align="center">
        Dados insuficientes para gerar o gráfico
      </Typography>
    </CardContent>
  </Card>
);
